'use client'

import Link from 'next/link'
import Image from 'next/image'
import { useEffect } from 'react'
import { ArrowRight, RotateCw } from 'lucide-react'
import SectionWrapper from '@/components/ui/SectionWrapper'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('Frontend route error:', error)
  }, [error])

  return (
    <SectionWrapper
      background="white"
      padding="lg"
      className="relative overflow-hidden min-h-[calc(100vh-200px)] flex items-center"
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 opacity-5 select-none">
          <Image
            src="/images/logo/Icon-pos.svg"
            alt=""
            width={800}
            height={800}
            className="object-contain only-light"
            priority
          />
          <Image
            src="/images/logo/Icon-neg.svg"
            alt=""
            width={800}
            height={800}
            className="object-contain only-dark"
            priority
          />
        </div>
      </div>

      <div className="relative z-10 w-full max-w-3xl mx-auto text-center">
        <h1 className="font-metropolis font-bold text-8xl md:text-9xl lg:text-[12rem] text-text-primary mb-6 tracking-tight">
          500
        </h1>

        <div className="mb-10">
          <h2 className="font-metropolis font-bold text-2xl md:text-3xl text-text-primary mb-4 uppercase tracking-wide">
            Ein Fehler ist aufgetreten
          </h2>
          <p className="font-ui text-base md:text-lg text-text-primary/80 max-w-md mx-auto">
            Die Seite konnte nicht geladen werden. Bitte versuchen Sie es erneut oder kehren Sie zur
            Startseite zurück.
          </p>
          {error.digest && (
            <p className="font-mono text-xs text-text-primary/40 mt-4">
              Referenz: {error.digest}
            </p>
          )}
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <button
            type="button"
            onClick={reset}
            className="inline-flex items-center justify-center gap-2 font-normal font-ui transition-all duration-300 focus:outline-none border text-lg px-6 py-4 bg-brand text-text-white hover:bg-brand/80 border-border-brand uppercase"
          >
            <RotateCw className="w-5 h-5" strokeWidth={2} />
            <span>Erneut versuchen</span>
          </button>
          <Link
            href="/"
            className="inline-flex items-center justify-center gap-2 font-normal font-ui transition-all duration-300 focus:outline-none border text-lg px-6 py-4 border-border-primary text-text-primary hover:bg-text-primary/5 uppercase"
          >
            <span>Zur Startseite</span>
            <ArrowRight className="w-5 h-5" strokeWidth={2} />
          </Link>
        </div>
      </div>
    </SectionWrapper>
  )
}
